module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm02_dedi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSO BY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARATI")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKHERJEE")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE TIGER’S DAUGHTER"), _c('br'), _vm._v("WIFE"), _c('br'), _vm._v("DARKNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("Nonfiction")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DAYS AND NIGHTS IN CALCUTTA"), _c('br'), _vm._v("THE SORROW AND THE TERROR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b558600","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02_dedi.vue
// module id = 60
// module chunks = 0